import React from "react";
import "./Map-Contact.css";

const Map_Contact = ({ all_app_setup }) => {
  const address = all_app_setup?.address || "";

  return (
    <div className="map-wrapper">
      <div className="map-container">
        <div className="container">
          <div className="map-card">
            <iframe
              title="location-map"
              src={`https://www.google.com/maps?q=${encodeURIComponent(
                address,
              )}&output=embed`}
              loading="lazy"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Map_Contact;
